/* M'Ayd the Label theme script
   Bag drawer, Quick add, size charts, product form, gallery and small section behaviours.
   Settings come from window.MAYD (snippets/mayd-global.liquid). */
(function () {
  'use strict';

  var CFG = window.MAYD || {};
  var ROUTES = CFG.routes || {};
  var ROOT = (ROUTES.root || '/').replace(/\/?$/, '/');

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function norm(s) { return String(s == null ? '' : s).toLowerCase().replace(/\s+/g, ''); }
  /* While the theme is an unpublished draft, keep background requests on the draft theme. */
  function themeUrl(url) {
    var t = window.Shopify && window.Shopify.theme;
    if (!t || !t.id || t.role === 'main' || /[?&]preview_theme_id=/.test(url)) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'preview_theme_id=' + t.id;
  }

  function formatMoney(cents) {
    var fmt = (CFG.showCurrencyCode ? CFG.moneyWithCurrencyFormat : CFG.moneyFormat) || '${{amount}}';
    cents = typeof cents === 'string' ? parseInt(cents.replace('.', ''), 10) : Math.round(cents || 0);
    function withDelims(n, precision, thousands, decimal) {
      var num = (n / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount': return withDelims(cents, 2, ',', '.');
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        case 'amount_with_space_separator': return withDelims(cents, 2, ' ', ',');
        default: return withDelims(cents, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }

  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {}))
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (!r.ok || data.status) {
            var err = new Error(data.description || data.message || 'Something went wrong. Please try again.');
            err.status = r.status;
            throw err;
          }
          return data;
        });
      });
  }

  function lengthInfo(value) {
    var key = norm(value);
    var list = CFG.lengths || [];
    for (var i = 0; i < list.length; i++) {
      if (norm(list[i].value) === key) return list[i];
    }
    return null;
  }

  function lines(text) {
    return String(text || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
  }

  /* ---------- analytics (Shopify standard events, as in Dawn) ---------- */
  var Events = {
    lines: function (el, action, context, lines) {
      var E = window.StandardEvents && window.StandardEvents.CartLinesUpdateEvent;
      if (!E) return null;
      try {
        var d = E.createPromise();
        el.dispatchEvent(new E({ action: action, context: context, lines: lines, promise: d.promise }));
        return d;
      } catch (e) { return null; }
    },
    resolve: function (d, cart) {
      if (!d) return;
      var E = window.StandardEvents && window.StandardEvents.CartLinesUpdateEvent;
      if (!E || !cart || !cart.currency) { d.reject(new Error('Missing cart')); return; }
      try { d.resolve({ cart: E.createCartFromAjaxResponse(cart) }); } catch (e) { /* ignore */ }
    },
    reject: function (d, err) { if (d) { try { d.reject(err); } catch (e) { /* ignore */ } } },
    error: function (el, message) {
      var E = window.StandardEvents && window.StandardEvents.CartErrorEvent;
      if (!E) return;
      try { el.dispatchEvent(new E({ error: message, code: 'INVALID' })); } catch (e) { /* ignore */ }
    },
    view: function (el, cart) {
      var E = window.StandardEvents && window.StandardEvents.CartViewEvent;
      if (!E || !cart || !cart.currency) return;
      try { el.dispatchEvent(new E({ context: 'dialog', cart: E.createCartFromAjaxResponse(cart) })); } catch (e) { /* ignore */ }
    },
    note: function (el, note) {
      var E = window.StandardEvents && window.StandardEvents.CartNoteUpdateEvent;
      if (!E) return null;
      try {
        var d = E.createPromise();
        el.dispatchEvent(new E({ context: 'dialog', note: note, promise: d.promise }));
        return d;
      } catch (e) { return null; }
    }
  };

  function publishCart(cart, source) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: source || 'mayd', cartData: cart });
      }
    } catch (e) { /* ignore */ }
  }

  /* keep keyboard focus inside an open window */
  function trapFocus(container, e) {
    if (e.key !== 'Tab' || !container) return;
    var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !container.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- windows (size chart, quick add) ---------- */
  var Modal = {
    stack: [],
    open: function (el) {
      if (!el) return;
      if (el.hidden) this.stack.push({ el: el, focus: document.activeElement });
      el.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var x = el.querySelector('.sc-x');
      if (x) x.focus();
    },
    close: function (el) {
      if (!el || el.hidden) return;
      el.hidden = true;
      var entry = null;
      this.stack = this.stack.filter(function (s) { if (s.el === el) { entry = s; return false; } return true; });
      if (!this.stack.length && !Cart.isOpen()) document.documentElement.style.overflow = '';
      if (entry && entry.focus && document.contains(entry.focus)) entry.focus.focus();
    },
    closeTop: function () {
      var top = this.stack[this.stack.length - 1];
      if (top) { this.close(top.el); return true; }
      return false;
    }
  };

  /* ---------- added message ---------- */
  var Toast = {
    i: 0,
    timer: null,
    messages: function () {
      var m = lines(CFG.addedMessages);
      return m.length ? m : ['Added to your bag'];
    },
    show: function (title, sub, img) {
      var t = $('#MaydToast');
      if (!t) return;
      $('#MaydToastTitle').textContent = title;
      $('#MaydToastSub').textContent = sub || '';
      var im = $('#MaydToastImage');
      if (img) { im.src = img; t.classList.remove('noimg'); } else { t.classList.add('noimg'); }
      t.classList.add('show');
      clearTimeout(this.timer);
      this.timer = setTimeout(function () { t.classList.remove('show'); }, 3600);
    },
    added: function (title, img, qty) {
      var list = this.messages();
      var msg = list[this.i % list.length];
      this.i++;
      this.show(msg, title + (qty > 1 ? ' x' + qty : '') + ' is in your bag', img);
    }
  };

  /* ---------- product data (from the page or the product-data section) ---------- */
  var Products = {
    cache: {},
    register: function (data) { if (data && data.handle) this.cache[data.handle] = Promise.resolve(data); },
    fromPage: function (handle) {
      var nodes = document.querySelectorAll('script[data-mayd-product-json]');
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].getAttribute('data-handle') !== handle) continue;
        try { return JSON.parse(nodes[i].textContent); } catch (err) { return null; }
      }
      return null;
    },
    get: function (handle) {
      if (!this.cache[handle]) {
        var onPage = this.fromPage(handle);
        if (onPage) { this.cache[handle] = Promise.resolve(onPage); return this.cache[handle]; }
      }
      if (!this.cache[handle]) {
        var url = themeUrl(ROOT + 'products/' + encodeURIComponent(handle) + '?sections=mayd-product-data');
        this.cache[handle] = fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('Section not available'); return r.json(); })
          .then(function (json) {
            var html = (json && json['mayd-product-data']) || '';
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var script = doc.querySelector('[data-mayd-product-json]');
            if (!script) throw new Error('Product data missing');
            return JSON.parse(script.textContent);
          })
          .catch(function () { return Products.fromAjax(handle); });
        this.cache[handle].catch(function () { delete Products.cache[handle]; });
      }
      return this.cache[handle];
    },
    /* Backup when the theme section can't be rendered (for example while the theme is an unpublished draft):
       build the same product data from Shopify's standard /products/handle.js endpoint. */
    fromAjax: function (handle) {
      return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('Product not found'); return r.json(); })
        .then(function (p) {
          var lengthKey = norm(CFG.lengthOption || 'Length');
          var img = function (src) { if (!src) return null; src = typeof src === 'string' ? src : src.src; if (!src) return null; src = (src.indexOf('//') === 0 ? 'https:' + src : src).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, ''); return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=400'; };
          var options = (p.options || []).map(function (o, i) {
            var name = typeof o === 'string' ? o : o.name;
            var values = typeof o === 'string' ? p.variants.map(function (v) { return v.options[i]; }).filter(function (v, j, a) { return a.indexOf(v) === j; }) : o.values;
            var key = norm(name);
            var isLength = key === lengthKey || (values.length && /^\s*\d+(\.\d+)?\s*cm\s*$/i.test(values[0]));
            var kind = isLength ? 'length' : (key.indexOf('colo') > -1 ? 'colour' : 'standard');
            return { name: name, kind: kind, values: values.map(function (v) { return { name: v, label: kind === 'colour' ? colourName(v) : v, swatch: kind === 'colour' ? swatchFor(colourName(v)) || swatchFor(v) : '' }; }) };
          });
          var guide = CFG.sizeGuideUrl || (ROOT + 'pages/size-guide');
          return {
            id: p.id, handle: p.handle, title: p.title, url: p.url || (ROOT + 'products/' + p.handle),
            available: p.available, price: p.price, image: img(p.featured_image), setBadge: '',
            options: options,
            variants: p.variants.map(function (v) {
              return { id: v.id, title: v.title, available: v.available, price: v.price, compare_at_price: v.compare_at_price || 0,
                options: v.options, media_id: v.featured_media ? v.featured_media.id : null, image: img(v.featured_image) };
            }),
            selected_variant: null, models: [],
            size_chart_html: '<p class="sc-note sc-note--first">See the full measurements on our <a href="' + esc(guide) + '">size guide</a>.</p>'
          };
        });
    }
  };

  function colourName(name) {
    var key = norm(name), out = String(name == null ? '' : name).trim();
    lines(CFG.colourNames).some(function (line) {
      var i = line.indexOf(':');
      if (i > 0 && norm(line.slice(0, i)) === key) { out = line.slice(i + 1).trim(); return true; }
      return false;
    });
    if (out && out === out.toLowerCase()) out = out.charAt(0).toUpperCase() + out.slice(1);
    return out;
  }

  function swatchFor(name) {
    var key = norm(name), hit = '';
    lines(CFG.swatches).some(function (line) {
      var i = line.indexOf(':');
      if (i > 0 && norm(line.slice(0, i)) === key) { hit = line.slice(i + 1).trim(); return true; }
      return false;
    });
    return hit || key;
  }

  /* ---------- option logic shared by the product page and Quick add ---------- */
  function OptionState(product, selections) {
    this.product = product;
    this.sel = selections;
  }
  OptionState.prototype.variant = function () {
    var sel = this.sel;
    if (sel.some(function (v) { return v == null; })) return null;
    return this.product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    }) || null;
  };
  OptionState.prototype.valueAvailable = function (index, value) {
    var sel = this.sel;
    return this.product.variants.some(function (v) {
      if (!v.available || v.options[index] !== value) return false;
      return v.options.every(function (o, i) { return i === index || sel[i] == null || o === sel[i]; });
    });
  };
  OptionState.prototype.missing = function () {
    var product = this.product;
    return this.sel.map(function (v, i) { return v == null ? product.options[i] : null; }).filter(Boolean);
  };
  OptionState.prototype.errorText = function () {
    var names = this.missing().map(function (o) {
      return o.kind === 'colour' ? 'colour' : String(o.name).toLowerCase();
    });
    if (!names.length) return '';
    if (names.length === 1) return 'Please choose your ' + names[0] + '.';
    return 'Please choose your ' + names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1] + '.';
  };

  function initialSelections(product, preselectAll) {
    var selected = product.selected_variant
      ? product.variants.find(function (v) { return v.id === product.selected_variant; })
      : null;
    var base = selected || product.variants.find(function (v) { return v.available; }) || product.variants[0];
    var all = preselectAll || !CFG.requireChoice || !!selected;
    return product.options.map(function (o, i) {
      if (all || o.kind === 'colour' || o.values.length === 1) return base ? base.options[i] : null;
      return null;
    });
  }

  function paintOptions(root, state) {
    $$('[data-option-index]', root).forEach(function (group) {
      var index = parseInt(group.getAttribute('data-option-index'), 10);
      var current = state.sel[index];
      $$('button[data-value]', group).forEach(function (btn) {
        var value = btn.getAttribute('data-value');
        btn.setAttribute('aria-pressed', String(value === current));
        var ok = state.valueAvailable(index, value);
        btn.classList.toggle('is-out', !ok);
        var label = btn.getAttribute('data-label') || value;
        btn.setAttribute('aria-label', ok ? label : label + ', sold out');
      });
      var name = $('[data-option-selected]', group);
      if (name) name.textContent = current ? colourName(current) : '';
    });
  }

  function fitTipHTML(product, state) {
    if (!product.models || !product.models.length) return '';
    var lenIdx = -1, sizeIdx = -1;
    product.options.forEach(function (o, i) {
      if (o.kind === 'length') lenIdx = i;
      else if (o.kind === 'standard' && sizeIdx === -1) sizeIdx = i;
    });
    if (lenIdx === -1) return '';
    var len = state.sel[lenIdx];
    var size = sizeIdx > -1 ? state.sel[sizeIdx] : null;
    var list = product.models.filter(function (m) { return m.length >= 3 && (!len || norm(m[3]) === norm(len)); });
    if (!list.length) return '';
    if (size) {
      var same = list.filter(function (m) { return norm(m[2]) === norm(String(size).replace(/^size\s*/i, '')); });
      if (same.length) list = same;
    }
    var m = list[0];
    var info = lengthInfo(m[3]);
    var lenText = m[3] ? ' in ' + (info ? info.label + ' (' + m[3] + ')' : m[3]) : '';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="12" cy="7" r="3.5"/><path d="M5 21c1.2-4 4-6 7-6s5.8 2 7 6"/></svg>' +
      '<span>' + esc(m[0]) + ' is ' + esc(m[1]) + ' and wears size ' + esc(m[2]) + esc(lenText) + '.</span>';
  }

  function optionsMarkup(product, state) {
    var html = '';
    product.options.forEach(function (o, i) {
      if (product.variants.length === 1 && o.values.length === 1 && /default/i.test(o.values[0].name)) return;
      var label = o.kind === 'colour' ? 'Colour' : o.name.charAt(0).toUpperCase() + o.name.slice(1).toLowerCase();
      html += '<div class="opt" data-option-index="' + i + '" data-option-kind="' + o.kind + '" role="group" aria-label="' + esc(label) + '">';
      html += '<div class="opt-head"><b>' + esc(label) + '</b>';
      if (o.kind === 'colour') html += '<span data-option-selected>' + esc(state.sel[i] ? colourName(state.sel[i]) : '') + '</span>';
      else if (o.kind === 'length') html += '<span>Buy for your height</span>';
      else if (!optionsMarkup.chartDone) { html += '<button type="button" class="link-btn" data-mayd-size-chart="' + esc(product.handle) + '">Size chart</button>'; optionsMarkup.chartDone = true; }
      html += '</div>';
      if (o.kind === 'colour') {
        html += '<div class="swatches">' + o.values.map(function (v) {
          var cl = v.label || colourName(v.name);
          return '<button type="button" data-value="' + esc(v.name) + '" data-label="' + esc(cl) + '" style="background:' + esc(v.swatch) + '" aria-label="' + esc(cl) + '" aria-pressed="false"></button>';
        }).join('') + '</div>';
      } else if (o.kind === 'length') {
        html += '<div class="lens">' + o.values.map(function (v) {
          var info = lengthInfo(v.name);
          var inner = info
            ? '<b>' + esc(info.label) + '</b><span>' + esc(info.height) + '</span>'
            : '<b>' + esc(v.name) + '</b>';
          return '<button type="button" data-value="' + esc(v.name) + '" data-label="' + esc(info ? info.label : v.name) + '" aria-pressed="false">' + inner + '</button>';
        }).join('') + '</div>';
      } else {
        html += '<div class="sizes">' + o.values.map(function (v) {
          return '<button type="button" data-value="' + esc(v.name) + '" data-label="' + esc(v.name) + '" aria-pressed="false">' + esc(String(v.name).replace(/^size\s+/i, '')) + '</button>';
        }).join('') + '</div>';
      }
      html += '</div>';
    });
    optionsMarkup.chartDone = false;
    return html;
  }

  /* ---------- the bag ---------- */
  var Cart = {
    el: null,
    data: null,
    lastFocus: null,
    init: function () {
      this.el = $('#MaydCart');
      if (!this.el) return;
      var self = this;
      document.addEventListener('click', function (e) {
        var icon = e.target.closest('#cart-icon-bubble, [data-mayd-cart-open]');
        if (icon && !e.metaKey && !e.ctrlKey) {
          if (document.querySelector('cart-items')) {
            if (icon.hasAttribute('data-mayd-cart-open')) { e.preventDefault(); window.location.href = ROUTES.cart || '/cart'; }
            return;
          }
          e.preventDefault(); self.open(); return;
        }
        if (e.target.closest('[data-mayd-cart-close]')) { e.preventDefault(); self.close(); }
      });
      this.el.addEventListener('click', function (e) {
        var q = e.target.closest('[data-line-change]');
        if (q) { self.change(q.getAttribute('data-key'), parseInt(q.getAttribute('data-qty'), 10)); }
      });
      var note = $('#MaydCartNote');
      if (note) {
        var t;
        note.addEventListener('input', function () {
          var field = $('#MaydCartNoteField');
          if (field) field.value = note.value;
          clearTimeout(t);
          t = setTimeout(function () { self.saveNote(note.value); }, 500);
        });
      }
      this.el.addEventListener('keydown', function (e) { if (self.isOpen()) trapFocus($('.panel', self.el), e); });
    },
    isOpen: function () { return !!(this.el && this.el.classList.contains('open')); },
    seq: 0,
    fetch: function () {
      var self = this;
      return fetchJSON((ROUTES.cart || '/cart') + '.js').then(function (cart) { self.data = cart; return cart; });
    },
    refresh: function () {
      var self = this;
      var mine = ++this.seq;
      return this.fetch().then(function (cart) {
        if (mine === self.seq) { self.render(cart); self.bubble(); }
        return cart;
      });
    },
    open: function () {
      if (!this.el) { window.location.href = ROUTES.cart || '/cart'; return; }
      var self = this;
      this.lastFocus = document.activeElement;
      this.el.classList.add('open');
      this.el.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var panel = $('.panel', this.el);
      setTimeout(function () { panel.focus(); }, 50);
      if (this.data) this.render(this.data);
      this.refresh().then(function (cart) { Events.view(self.el, cart); }).catch(function () {});
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('open');
      this.el.setAttribute('aria-hidden', 'true');
      if (!Modal.stack.length) document.documentElement.style.overflow = '';
      if (this.lastFocus && document.contains(this.lastFocus)) this.lastFocus.focus();
    },
    bubble: function () {
      var holder = $('#cart-icon-bubble');
      if (!holder) return Promise.resolve();
      return fetch(themeUrl(ROOT + '?sections=cart-icon-bubble'))
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var html = json['cart-icon-bubble'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.querySelector('.shopify-section') || doc.body;
          holder.innerHTML = src.innerHTML;
        })
        .catch(function () {});
    },
    variantText: function (item) {
      var parts = [];
      (item.options_with_values || []).forEach(function (o) {
        if (/default title/i.test(o.value)) return;
        var info = (norm(o.name) === norm(CFG.lengthOption) || /^\s*\d+(\.\d+)?\s*cm\s*$/i.test(o.value)) ? lengthInfo(o.value) : null;
        if (info) parts.push(info.label + ' (' + o.value + ')');
        else if (/^size$/i.test(o.name) && !/^size/i.test(o.value)) parts.push('Size ' + o.value);
        else if (/colo/i.test(o.name)) parts.push(colourName(o.value));
        else parts.push(o.value);
      });
      return parts.join(', ');
    },
    render: function (cart) {
      if (!this.el || !cart) return;
      var items = $('#MaydCartItems'), foot = $('#MaydCartFoot'), ship = $('#MaydCartShip');
      var self = this;
      // free shipping bar
      if (ship && CFG.freeShipping > 0) {
        var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
        var threshold = Math.round(CFG.freeShipping * rate);
        var left = threshold - cart.total_price;
        var pct = Math.max(0, Math.min(100, cart.total_price / threshold * 100));
        var text = !cart.item_count
          ? 'Free shipping on orders over ' + formatMoney(threshold)
          : left > 0
            ? esc(CFG.freeShippingAway || '').replace('[amount]', '<b>' + esc(formatMoney(left)) + '</b>')
            : esc(CFG.freeShippingDone || '');
        ship.innerHTML = '<span>' + text + '</span>' + (cart.item_count ? '<div class="bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '"><i style="width:' + pct + '%"></i></div>' : '');
        ship.hidden = false;
      }
      if (!cart.item_count) {
        items.innerHTML = '<div class="cart-empty"><p>Your bag is empty.</p><button type="button" class="btn solid" data-mayd-cart-close>Continue shopping</button></div>';
        foot.hidden = true;
        return;
      }
      items.innerHTML = cart.items.map(function (item) {
        var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
        var disc = (item.line_level_discount_allocations || []).map(function (a) {
          return '<p class="d">' + esc(a.discount_application && a.discount_application.title || 'Discount') + ' (&minus;' + esc(formatMoney(a.amount)) + ')</p>';
        }).join('');
        var original = item.original_line_price > item.final_line_price ? '<s>' + esc(formatMoney(item.original_line_price)) + '</s>' : '';
        return '<div class="ci">' +
          '<a href="' + esc(item.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="76" height="98">' : '') + '</a>' +
          '<div><a href="' + esc(item.url) + '"><b>' + esc(item.product_title) + '</b></a>' +
          '<div class="v">' + esc(self.variantText(item)) + '</div>' + disc +
          '<span class="q"><button type="button" data-line-change data-key="' + esc(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
          '<span aria-label="Quantity">' + item.quantity + '</span>' +
          '<button type="button" data-line-change data-key="' + esc(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button></span>' +
          '<button type="button" class="rm" data-line-change data-key="' + esc(item.key) + '" data-qty="0">Remove</button></div>' +
          '<span class="lp">' + esc(formatMoney(item.final_line_price)) + original + '</span></div>';
      }).join('') + '<p class="cart-error" id="MaydCartError" role="alert" hidden></p>';

      // totals with discounts grouped by name
      var discounts = {};
      cart.items.forEach(function (item) {
        (item.line_level_discount_allocations || []).forEach(function (a) {
          var t = (a.discount_application && a.discount_application.title) || 'Discount';
          discounts[t] = (discounts[t] || 0) + a.amount;
        });
      });
      (cart.cart_level_discount_applications || []).forEach(function (d) {
        discounts[d.title || 'Discount'] = (discounts[d.title || 'Discount'] || 0) + (d.total_allocated_amount || 0);
      });
      var rows = '<div class="row"><span>Subtotal</span><span>' + esc(formatMoney(cart.original_total_price)) + '</span></div>';
      Object.keys(discounts).forEach(function (t) {
        if (discounts[t] > 0) rows += '<div class="row disc"><span>' + esc(t) + '</span><span>&minus;' + esc(formatMoney(discounts[t])) + '</span></div>';
      });
      rows += '<div class="row tot"><span>Total</span><span>' + esc(formatMoney(cart.total_price)) + '</span></div>';
      $('#MaydCartTotals').innerHTML = rows;
      var note = $('#MaydCartNote');
      if (note && document.activeElement !== note) note.value = cart.note || '';
      foot.hidden = false;
    },
    change: function (key, qty) {
      var self = this;
      if (qty < 0 || !key) return;
      this.el.classList.add('is-busy');
      var d = Events.lines(this.el, qty === 0 ? 'remove' : 'update', 'cart', [{ id: key, quantity: qty }]);
      this.seq++;
      fetchJSON((ROUTES.cartChange || '/cart/change') + '.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (cart) {
          self.data = cart;
          self.render(cart);
          self.bubble();
          Events.resolve(d, cart);
          publishCart(cart, 'mayd-cart');
        })
        .catch(function (err) {
          Events.reject(d, err);
          Events.error(self.el, err.message);
          self.refresh().then(function () {
            var box = $('#MaydCartError');
            if (box) { box.textContent = err.message; box.hidden = false; }
          });
        })
        .then(function () { self.el.classList.remove('is-busy'); });
    },
    saveNote: function (note) {
      var d = Events.note(this.el, note);
      fetchJSON((ROUTES.cartUpdate || '/cart/update') + '.js', { method: 'POST', body: JSON.stringify({ note: note }) })
        .then(function (cart) {
          var E = window.StandardEvents && window.StandardEvents.CartNoteUpdateEvent;
          if (d && E) { try { d.resolve({ cart: E.createCartFromAjaxResponse(cart) }); } catch (e) { /* ignore */ } }
        })
        .catch(function (err) { Events.reject(d, err); });
    },
    add: function (variantId, qty, meta, sourceEl) {
      var self = this;
      qty = qty || 1;
      var el = sourceEl || document.body;
      var d = Events.lines(el, 'add', 'product', [{ merchandiseId: String(variantId), quantity: qty }]);
      return fetchJSON((ROUTES.cartAdd || '/cart/add') + '.js', { method: 'POST', body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }) })
        .then(function () { return self.fetch(); })
        .then(function (cart) {
          self.seq++;
          Events.resolve(d, cart);
          self.render(cart);
          self.bubble();
          publishCart(cart, 'mayd-add');
          if (CFG.openCartOnAdd) self.open();
          else if (meta) Toast.added(meta.title, meta.image, qty);
          return cart;
        })
        .catch(function (err) {
          Events.reject(d, err);
          Events.error(el, err.message);
          throw err;
        });
    }
  };

  /* ---------- size chart window ---------- */
  var SizeChart = {
    open: function (handle) {
      var modal = $('#MaydSizeChart');
      if (!modal) { window.location.href = CFG.sizeGuideUrl || (ROOT + 'pages/size-guide'); return; }
      $('#MaydSizeChartTitle').textContent = 'Size chart';
      $('#MaydSizeChartContent').innerHTML = '<p class="sc-loading">Loading…</p>';
      Modal.open(modal);
      Products.get(handle).then(function (p) {
        $('#MaydSizeChartTitle').textContent = p.title;
        $('#MaydSizeChartContent').innerHTML = p.size_chart_html || '';
      }).catch(function () {
        $('#MaydSizeChartContent').innerHTML = '<p class="sc-note sc-note--first">Sorry, the size chart could not be loaded. Please try again.</p>';
      });
    }
  };

  /* ---------- quick add window ---------- */
  var QuickAdd = {
    product: null,
    state: null,
    queue: [],
    init: function () {
      var self = this;
      var modal = $('#MaydQuickAdd');
      if (!modal) return;
      modal.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-option-index] button[data-value]');
        if (btn && self.state) {
          var i = parseInt(btn.closest('[data-option-index]').getAttribute('data-option-index'), 10);
          self.state.sel[i] = btn.getAttribute('data-value');
          $('#MaydQuickAddError').textContent = '';
          self.paint();
        }
      });
      $('#MaydQuickAddButton').addEventListener('click', function () { self.submit(); });
      $$('[data-mayd-modal-close]', modal).forEach(function (b) { b.addEventListener('click', function () { self.queue = []; }); });
    },
    open: function (handle, queue) {
      var self = this;
      var modal = $('#MaydQuickAdd');
      if (!modal) { window.location.href = ROOT + 'products/' + handle; return; }
      this.queue = queue || [];
      Products.get(handle).then(function (p) {
        self.product = p;
        self.state = new OptionState(p, initialSelections(p, false));
        $('#MaydQuickAddTitle').textContent = p.title;
        $('#MaydQuickAddImage').src = p.image || 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
        $('#MaydQuickAddImage').alt = p.title;
        $('#MaydQuickAddFull').href = p.url;
        $('#MaydQuickAddError').textContent = '';
        var step = self.queue.length ? '<p class="qa-step">Step 1 of 2: choose this piece, then the next.</p>' : (self.stepTwo ? '<p class="qa-step">Step 2 of 2</p>' : '');
        self.stepTwo = false;
        $('#MaydQuickAddOptions').innerHTML = step + optionsMarkup(p, self.state);
        self.paint();
        Modal.open(modal);
      }).catch(function () {
        window.location.href = ROOT + 'products/' + handle;
      });
    },
    paint: function () {
      var modal = $('#MaydQuickAdd');
      paintOptions(modal, this.state);
      var v = this.state.variant();
      var price = v ? v.price : this.product.price;
      $('#MaydQuickAddPrice').textContent = formatMoney(price);
      var btn = $('#MaydQuickAddButton');
      if (v && !v.available) { btn.textContent = 'Sold out'; btn.disabled = true; }
      else { btn.textContent = 'Add to bag'; btn.disabled = false; }
    },
    submit: function () {
      var self = this;
      var err = $('#MaydQuickAddError');
      var missing = this.state.errorText();
      if (missing) { err.textContent = missing; return; }
      var v = this.state.variant();
      if (!v || !v.available) { err.textContent = 'This combination is sold out. Please choose another.'; return; }
      var btn = $('#MaydQuickAddButton');
      btn.classList.add('is-loading');
      Cart.add(v.id, 1, { title: this.product.title, image: v.image || this.product.image }, btn)
        .then(function () {
          var modal = $('#MaydQuickAdd');
          var next = self.queue.shift();
          if (next) {
            self.stepTwo = true;
            var rest = self.queue;
            Modal.close(modal);
            setTimeout(function () { self.open(next, rest); }, 250);
          } else {
            Modal.close(modal);
          }
        })
        .catch(function (e) { err.textContent = e.message; })
        .then(function () { btn.classList.remove('is-loading'); });
    }
  };

  /* ---------- product page ---------- */
  try {
  if (!customElements.get('mayd-product')) {
    customElements.define('mayd-product', class extends HTMLElement {
      connectedCallback() {
        var script = this.querySelector('[data-mayd-product-json]');
        if (!script) return;
        try { this.product = JSON.parse(script.textContent); } catch (e) { return; }
        Products.register(this.product);
        this.state = new OptionState(this.product, this.readSelections());
        this.form = this.querySelector('[data-mayd-product-form]');
        this.addBtn = this.querySelector('[data-add-button]');
        this.error = this.querySelector('[data-product-error]');
        if (!this.error) {
          this.error = document.createElement('p');
          this.error.className = 'err';
          this.error.setAttribute('role', 'alert');
          var host = this.querySelector('.buy-block') || this.querySelector('.info') || this;
          host.insertBefore(this.error, host.firstChild);
        }
        this.track = this.querySelector('[data-gallery-track]');
        this.bind();
        this.update(false);
        this.initGallery();
        this.initSticky();
      }
      readSelections() {
        var product = this.product;
        return product.options.map(function (o, i) {
          var pressed = this.querySelector('[data-option-index="' + i + '"] button[aria-pressed="true"]');
          if (pressed) return pressed.getAttribute('data-value');
          if (o.values.length === 1) return o.values[0].name;
          return null;
        }, this);
      }
      bind() {
        var self = this;
        this.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-option-index] button[data-value]');
          if (btn && self.contains(btn)) {
            var i = parseInt(btn.closest('[data-option-index]').getAttribute('data-option-index'), 10);
            self.state.sel[i] = btn.getAttribute('data-value');
            self.error.textContent = '';
            self.update(true);
            if (self.product.options[i].kind === 'colour') self.showVariantMedia();
            return;
          }
          var q = e.target.closest('[data-qty]');
          if (q) {
            var input = self.querySelector('[data-qty-input]');
            input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(q.getAttribute('data-qty'), 10));
            return;
          }
          if (e.target.closest('[data-buy-now]')) { self.submit(true); return; }
          if (e.target.closest('[data-sticky-add]')) { self.submit(false); }
        });
        if (this.form) {
          this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(false); });
        }
      }
      update(changeUrl) {
        paintOptions(this, this.state);
        var v = this.state.variant();
        var price = v ? v.price : (this.product.variants.find(function (x) { return x.available; }) || this.product.variants[0]).price;
        var compare = v ? v.compare_at_price : 0;
        var priceEl = this.querySelector('[data-product-price]');
        if (priceEl) priceEl.innerHTML = esc(formatMoney(price)) + (compare > price ? ' <s>' + esc(formatMoney(compare)) + '</s>' : '');
        var sticky = this.querySelector('[data-sticky-price]');
        if (sticky) sticky.textContent = formatMoney(price);
        $$('input[name="id"]', this).forEach(function (i) { if (v) i.value = v.id; });
        var inst = document.getElementById('MaydInstallments');
        if (inst && v) { var ii = inst.querySelector('input[name="id"]'); if (ii) { ii.value = v.id; ii.dispatchEvent(new Event('change', { bubbles: true })); } }
        var soldOut = v ? !v.available : !this.product.available;
        if (this.addBtn) {
          this.addBtn.disabled = soldOut;
          this.addBtn.textContent = soldOut ? 'Sold out' : 'Add to bag';
        }
        var buyNow = this.querySelector('[data-buy-now]');
        if (buyNow) buyNow.hidden = soldOut;
        var stickyBtn = this.querySelector('[data-sticky-add]');
        if (stickyBtn) { stickyBtn.disabled = soldOut; stickyBtn.textContent = soldOut ? 'Sold out' : 'Add to bag'; }
        var notify = this.closest('.mayd-pdp') && this.closest('.mayd-pdp').querySelector('[data-notify-box]');
        if (notify) {
          notify.hidden = !soldOut;
          var body = notify.querySelector('[data-notify-body]');
          if (body && v) body.value = 'Back in stock request: ' + this.product.title + ' - ' + v.title;
        }
        var tip = this.querySelector('[data-fit-tip]');
        if (tip) {
          var html = fitTipHTML(this.product, this.state);
          tip.innerHTML = html;
          tip.hidden = !html;
        }
        if (changeUrl && v && window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
      }
      submit(buyNow) {
        var self = this;
        var missing = this.state.errorText();
        if (missing) {
          this.error.textContent = missing;
          var group = this.querySelector('[data-option-index] button[aria-pressed="false"]');
          var firstMissing = this.state.sel.indexOf(null);
          var target = this.querySelector('[data-option-index="' + firstMissing + '"]') || group;
          if (target) target.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        var v = this.state.variant();
        if (!v || !v.available) { this.error.textContent = 'This combination is sold out. Please choose another.'; return; }
        var qtyInput = this.querySelector('[data-qty-input]');
        var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
        if (buyNow) {
          // Straight to checkout with just this item, like Shopify's own Buy it now
          window.location.href = ROOT + 'cart/' + v.id + ':' + qty;
          return;
        }
        var btn = this.addBtn;
        if (btn) btn.classList.add('is-loading');
        Cart.add(v.id, qty, { title: this.product.title, image: v.image || this.product.image }, this)
          .catch(function (e) { self.error.textContent = e.message; })
          .then(function () { if (btn) btn.classList.remove('is-loading'); });
      }
      showVariantMedia() {
        var v = this.state.variant();
        var colourIdx = this.product.options.findIndex(function (o) { return o.kind === 'colour'; });
        if (!v && colourIdx > -1) {
          var colour = this.state.sel[colourIdx];
          v = this.product.variants.find(function (x) { return x.options[colourIdx] === colour && x.media_id; });
        }
        if (!v || !v.media_id || !this.track) return;
        var slides = $$('.slide', this.track);
        var idx = slides.findIndex(function (s) { return String(s.getAttribute('data-media-id')) === String(v.media_id); });
        if (idx > -1) this.goTo(idx);
      }
      initGallery() {
        var self = this;
        if (!this.track) return;
        this.slides = $$('.slide', this.track);
        this.index = 0;
        $$('[data-gallery-thumb]', this).forEach(function (b) {
          b.addEventListener('click', function () { self.goTo(parseInt(b.getAttribute('data-gallery-thumb'), 10)); });
        });
        var prev = this.querySelector('[data-gallery-prev]'), next = this.querySelector('[data-gallery-next]');
        if (prev) prev.addEventListener('click', function () { self.goTo(self.index - 1); });
        if (next) next.addEventListener('click', function () { self.goTo(self.index + 1); });
        var t;
        this.track.addEventListener('scroll', function () {
          clearTimeout(t);
          t = setTimeout(function () {
            var w = self.track.clientWidth || 1;
            self.index = Math.round(self.track.scrollLeft / w);
            self.syncGallery();
          }, 60);
        }, { passive: true });
        this.track.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.index + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(self.index - 1); }
        });
      }
      goTo(i) {
        var n = this.slides ? this.slides.length : 0;
        if (!n) return;
        this.index = (i + n) % n;
        this.track.scrollTo({ left: this.track.clientWidth * this.index, behavior: 'smooth' });
        this.syncGallery();
      }
      syncGallery() {
        var self = this;
        var count = this.querySelector('[data-gallery-count]');
        if (count) count.textContent = (this.index + 1) + ' / ' + this.slides.length;
        $$('[data-gallery-thumb]', this).forEach(function (b, k) {
          if (k === self.index) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
        });
      }
      initSticky() {
        var bar = this.querySelector('[data-sticky-buy]');
        var btn = this.addBtn;
        if (!bar || !btn) return;
        var ticking = false;
        var check = function () {
          ticking = false;
          var passed = btn.getBoundingClientRect().bottom < 0;
          bar.classList.toggle('show', passed);
          bar.setAttribute('aria-hidden', String(!passed));
          var b = bar.querySelector('[data-sticky-add]');
          if (b) b.tabIndex = passed ? 0 : -1;
        };
        window.addEventListener('scroll', function () {
          if (!ticking) { ticking = true; requestAnimationFrame(check); }
        }, { passive: true });
        check();
      }
    });
  }
  } catch (err) { if (window.console) console.error('[M\'Ayd] ' + 'mayd-product', err); }

  /* ---------- length finder ---------- */
  try {
  if (!customElements.get('mayd-length-finder')) {
    customElements.define('mayd-length-finder', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.addEventListener('click', function (e) {
          var b = e.target.closest('[data-finder-index]');
          if (!b) return;
          var i = b.getAttribute('data-finder-index');
          $$('[data-finder-index]', self).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          $$('[data-finder-result]', self).forEach(function (r) { r.hidden = r.getAttribute('data-finder-result') !== i; });
        });
      }
    });
  }
  } catch (err) { if (window.console) console.error('[M\'Ayd] ' + 'mayd-length-finder', err); }

  /* ---------- complete the look ---------- */
  try {
  if (!customElements.get('mayd-complete-look')) {
    customElements.define('mayd-complete-look', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        var main = this.querySelector('.look-img img');
        this.addEventListener('click', function (e) {
          var li = e.target.closest('[data-look-image]');
          if (li) {
            if (li.classList.contains('active')) return;
            $$('[data-look-image]', self).forEach(function (x) { x.classList.toggle('active', x === li); });
            if (main && li.getAttribute('data-look-image')) {
              main.style.opacity = 0;
              setTimeout(function () {
                main.removeAttribute('srcset');
                main.src = li.getAttribute('data-look-image');
                main.alt = li.getAttribute('data-look-alt') || '';
                var done = function () { main.style.opacity = 1; };
                main.onload = done;
                setTimeout(done, 400);
              }, 200);
            }
            return;
          }
          if (e.target.closest('[data-look-add]')) {
            var handles = (self.getAttribute('data-handles') || '').split(',').filter(Boolean);
            if (handles.length) QuickAdd.open(handles[0], handles.slice(1));
          }
        });
      }
    });
  }
  } catch (err) { if (window.console) console.error('[M\'Ayd] ' + 'mayd-complete-look', err); }

  /* ---------- tabs (size guide) ---------- */
  try {
  if (!customElements.get('mayd-tabs')) {
    customElements.define('mayd-tabs', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        var tabs = $$('[role="tab"]', this);
        tabs.forEach(function (tab, k) {
          tab.addEventListener('click', function () { self.select(tab); });
          tab.addEventListener('keydown', function (e) {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            var n = tabs[(k + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
            n.focus();
            self.select(n);
          });
        });
      }
      select(tab) {
        $$('[role="tab"]', this).forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
    });
  }
  } catch (err) { if (window.console) console.error('[M\'Ayd] ' + 'mayd-tabs', err); }

  /* ---------- recommendations ---------- */
  try {
  if (!customElements.get('mayd-recommendations')) {
    customElements.define('mayd-recommendations', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        if (this.querySelector('.pc')) return;
        var url = this.getAttribute('data-url');
        if (!url) return;
        var load = function () {
          fetch(themeUrl(url)).then(function (r) { return r.text(); }).then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var fresh = doc.querySelector('mayd-recommendations');
            if (fresh && fresh.querySelector('.pc')) {
              self.innerHTML = fresh.innerHTML;
              var section = self.closest('[data-mayd-related]');
              if (section) section.hidden = false;
            }
          }).catch(function () {});
        };
        var done = false;
        var once = function () { if (!done) { done = true; load(); } };
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) { io.disconnect(); once(); }
          }, { rootMargin: '600px 0px 600px 0px' });
          io.observe(this.closest('.shopify-section') || this);
        }
        // also load shortly after the page has loaded, in case the shopper jumps past it
        var later = function () { setTimeout(once, 2500); };
        if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
      }
    });
  }
  } catch (err) { if (window.console) console.error('[M\'Ayd] ' + 'mayd-recommendations', err); }


  /* ---------- collection filters and sort (approved M'Ayd design) ---------- */
  var Filters = {
    init: function () {
      var panel = $('#MaydFilters');
      var grid = $('#product-grid');
      if (!panel || !grid) return;
      this.panel = panel;
      this.grid = grid;
      this.items = $$('li[data-mf-price]', grid);
      this.tile = $('[data-mf-tile]', grid);
      this.sortSelect = $('[data-mf-sort]');
      var self = this;
      panel.addEventListener('change', function () { self.apply(); });
      if (this.sortSelect) this.sortSelect.addEventListener('change', function () { self.apply(); });
      $$('[data-mf-clear]').forEach(function (b) { b.addEventListener('click', function () { self.clear(); }); });
      $$('[data-mf-open]').forEach(function (b) { b.addEventListener('click', function () { self.open(); }); });
      $$('[data-mf-close]', panel).forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('open')) self.close(); });
    },
    open: function () { this.panel.classList.add('open'); document.documentElement.style.overflow = 'hidden'; var x = $('.mf-x', this.panel); if (x) x.focus(); },
    close: function () { this.panel.classList.remove('open'); document.documentElement.style.overflow = ''; var o = $('[data-mf-open]'); if (o) o.focus(); },
    checked: function (name) { return $$('input[name="' + name + '"]:checked', this.panel).map(function (i) { return i.value; }); },
    clear: function () { $$('input[type=checkbox]', this.panel).forEach(function (i) { i.checked = false; }); this.apply(); },
    apply: function () {
      var lengths = this.checked('length'), colours = this.checked('colour'), prices = this.checked('price');
      var stock = this.checked('stock').length > 0;
      var sort = this.sortSelect ? this.sortSelect.value : 'featured';
      var active = lengths.length || colours.length || prices.length || stock;
      var visible = 0;
      this.items.forEach(function (li) {
        var d = li.dataset, ok = true;
        var lenList = stock ? d.mfLengths : d.mfLengthsAny;
        var colList = stock ? d.mfColours : d.mfColoursAny;
        if (lengths.length && !lengths.some(function (v) { return (lenList || '').indexOf('|' + v + '|') > -1; })) ok = false;
        if (ok && colours.length && !colours.some(function (v) { return (colList || '').indexOf('|' + v + '|') > -1; })) ok = false;
        if (ok && prices.length) {
          var price = parseInt(d.mfPrice, 10) || 0;
          ok = prices.some(function (r) { var p = r.split('-'); return price >= +p[0] && price <= +p[1]; });
        }
        if (ok && stock && d.mfStock !== '1') ok = false;
        if (ok) { li.removeAttribute('data-mf-hidden'); visible++; } else li.setAttribute('data-mf-hidden', '');
      });
      var order = this.items.slice();
      if (sort === 'price-asc') order.sort(function (a, b) { return a.dataset.mfPrice - b.dataset.mfPrice || a.dataset.mfIndex - b.dataset.mfIndex; });
      else if (sort === 'price-desc') order.sort(function (a, b) { return b.dataset.mfPrice - a.dataset.mfPrice || a.dataset.mfIndex - b.dataset.mfIndex; });
      else if (sort === 'title') order.sort(function (a, b) { return a.dataset.mfTitle < b.dataset.mfTitle ? -1 : a.dataset.mfTitle > b.dataset.mfTitle ? 1 : 0; });
      else order.sort(function (a, b) { return a.dataset.mfIndex - b.dataset.mfIndex; });
      var grid = this.grid, tile = this.tile;
      order.forEach(function (li, i) {
        grid.appendChild(li);
        if (tile && i === 1) grid.appendChild(tile);
      });
      if (tile) { if (active || sort !== 'featured') tile.setAttribute('data-mf-hidden', ''); else tile.removeAttribute('data-mf-hidden'); }
      var count = $('[data-mf-count]');
      if (count) count.textContent = visible + (visible === 1 ? ' product' : ' products');
      var empty = $('[data-mf-empty]');
      if (empty) empty.hidden = visible > 0;
    }
  };

  /* ---------- global clicks and keys ---------- */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-mayd-quick-add]');
    if (qa) { e.preventDefault(); QuickAdd.open(qa.getAttribute('data-mayd-quick-add')); return; }
    var sc = e.target.closest('[data-mayd-size-chart]');
    if (sc) { e.preventDefault(); SizeChart.open(sc.getAttribute('data-mayd-size-chart')); return; }
    var close = e.target.closest('[data-mayd-modal-close]');
    if (close) { e.preventDefault(); Modal.close(close.closest('.sc-modal')); }
   }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab' && Modal.stack.length) { trapFocus(Modal.stack[Modal.stack.length - 1].el, e); return; }
    if (e.key !== 'Escape') return;
    if (Modal.closeTop()) return;
    if (Cart.isOpen()) Cart.close();
  });

  function start() {
    try { Cart.init(); } catch (err) { if (window.console) console.error('[M\'Ayd] bag', err); }
    try { QuickAdd.init(); } catch (err) { if (window.console) console.error('[M\'Ayd] quick add', err); }
    try { Filters.init(); } catch (err) { if (window.console) console.error('[M\'Ayd] filters', err); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.MaydCart = {
    open: function () { Cart.open(); },
    close: function () { Cart.close(); },
    refresh: function () { return Cart.refresh(); },
    add: function (id, qty) { return Cart.add(id, qty); }
  };
  window.MaydQuickAdd = QuickAdd;
  window.MaydSizeChart = SizeChart;
  window.MaydFormatMoney = formatMoney;
})();
